import React from 'react';
import { NextPageWithLayout } from './page';
const GamesComponent = dynamic(() => import('../components/pages/Games/GamesComponent'), { ssr: false });
import Head from 'next/head';
import GamesLayout from '../components/layouts/games';
import { t } from 'i18next';
import dynamic from 'next/dynamic';
import WheelBonusPopupManager from 'Components/pages/WheelBonus/WheelBonusPopupManager';

interface IGamePageProps {
  category?: string;
  provider?: string;
}
export const getServerSideProps = async ({ query }) => {
  const { category = null, provider = null } = query;

  return {
    props: {
      category,
      provider,
    },
  };
};
const GamesPage: NextPageWithLayout = ({ provider }: IGamePageProps) => {
  return (
    <>
      <GamesComponent provider={provider} />
      <WheelBonusPopupManager />
    </>
  );
};

GamesPage.getLayout = page => {
  return (
    <React.Fragment>
      <Head>
        <title>{t('page.games.meta.title')}</title>
        <meta name="description" content={t('page.games.meta.description')} />
      </Head>
      <GamesLayout>{page}</GamesLayout>
    </React.Fragment>
  );
};

export default GamesPage;
